import { Component, OnInit } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-ing_animacion',
  templateUrl: './ing_animacion.component.html',
  styleUrls: ['./ing_animacion.component.css'],
  imports: [RouterLink]
})
export class Ing_animacionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
